'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import UITooltip from 'UIComponents/tooltip/UITooltip';

const SafeTooltip = (_ref) => {
  let {
    children,
    disabled
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "disabled"]);

  if (disabled) {
    return children;
  }

  return /*#__PURE__*/_jsx(UITooltip, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx("span", {
      children: children
    })
  }));
};

export default SafeTooltip;